import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSubscriptionPlan = createAsyncThunk(
  'subscription/fetchSubscriptionPlan',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch('/api/settings/account/subscription?minimal=true');
      if (!res.ok) throw new Error('Failed to fetch subscription');
      const data = await res.json();
      return data.planType || null;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  planType: null,
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    clearSubscription: (state) => {
      state.planType = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.planType = action.payload;
      })
      .addCase(fetchSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer; 